import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/connections.png'


const _hoisted_1 = { class: "overview app-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "40",
    height: "40",
    alt: "clients"
  })
], -1)
const _hoisted_3 = { class: "num" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "node-status-dot is-running" }, null, -1)
const _hoisted_5 = { class: "num" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "node-status-dot is-running" }, null, -1)
const _hoisted_7 = { class: "num" }

import { ref, reactive, Ref, watch } from 'vue'
import Moment from 'moment'
import { formatNumber } from '@/common/tools'
import { getOrderStat } from '@/api/operation'
// import { Right } from '@element-plus/icons-vue'
// import useSyncPolling from '@/hooks/useSyncPolling'
import useI18nTl from '@/hooks/useI18nTl'
import ConnectorStatePie from '@/components/ConnectorStatePie.vue'
import OrderTrend from '@/components/OrderTrend.vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'HomeStyleEn',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  operatorId: {
    type: String,
    required: false,
    default: '0',
  },
},
  setup(__props) {

const props = __props



const { t, tl } = useI18nTl('Dashboard')
const isLoading = ref(false)
const statTime = ref('')
const beginTime = ref('')
const endTime = ref('')
const stat = ref({ totalOrderNum: 0, totalElec: 0, totalAmount: 0 })

const _formatNumber = (num: number) => (num === undefined ? 0 : formatNumber(num))

watch(statTime, () => {
  if (statTime.value) {
    beginTime.value = Moment(statTime.value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
    endTime.value = Moment(statTime.value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
  } else {
    beginTime.value = ''
    endTime.value = ''
  }
  loadData()
})

const loadData = async () => {
  try {
    isLoading.value = true

    const data = await getOrderStat({
      beginTime: beginTime.value,
      endTime: endTime.value,
      operatorID: props.operatorId,
    })
    if (!data) {
      return
    }
    stat.value = data.stat
  } catch (error) {
    //
  } finally {
    isLoading.value = false
  }
}

const getNow = () => {
  return Moment().format('HH:mm:ss')
}

// const { syncPolling } = useSyncPolling()
// syncPolling(loadData, POLLING_INTERVAL)
loadData()

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "block",
      gutter: 20
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(ConnectorStatePie, {
              operatorId: props.operatorId
            }, null, 8, ["operatorId"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 16,
          class: "main-info-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "with-multiple-counts" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 16 }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: statTime.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statTime).value = $event)),
                          type: "month",
                          placeholder: _unref(tl)('allOrderStat')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: { name: 'sessions' } }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('Dashboard.sessions')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_formatNumber(stat.value.totalOrderNum)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "no-img",
                          to: { name: 'sessions' }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('Dashboard.energy')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_formatNumber(stat.value.totalElec)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "no-img",
                          to: { name: 'sessions' }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('Dashboard.fees')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_formatNumber(stat.value.totalAmount)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      class: "block",
      gutter: 20
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "trend-card" }, {
              default: _withCtx(() => [
                _createVNode(OrderTrend, {
                  operatorId: props.operatorId
                }, null, 8, ["operatorId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})